import React, { useState } from "react";
import { Warning } from "@material-ui/icons";

export default function CancellationModal({ title, setOpen, onConfirm, defaultId, reasonMaxLength }) {
  const [isLoading, setIsLoading] = useState(false);
  const [id] = useState(defaultId || "");
  const [cancellationReason, setCancellationReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (!cancellationReason.trim()) {
      setError("O motivo é obrigatório.");
      return;
    }
    setError("");
    setIsLoading(true);
    try {
      await onConfirm({ id, cancellationReason });
    } finally {
      setIsLoading(false);
    }
  };
const handleHoverStyle = (e, bgColor, textColor) => {
  if (isLoading) return;

  e.currentTarget.style.backgroundColor = bgColor;
  e.currentTarget.style.color = textColor;
};


  const handleDismiss = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.45)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "32px",
          minWidth: "420px",
          maxWidth: "500px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          textAlign: "center"
        }}
      >
        <div style={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          backgroundColor: "#FFE2E5",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 16px"
        }}>
          <Warning style={{ color: "#F64E60", fontSize: 32 }} />
        </div>

        <h2 style={{ marginBottom: 4, fontSize: "20px" }}>Cancelar {title}</h2>
        <p style={{ color: "#B5B5C3", fontSize: "14px", marginBottom: 20 }}>
          Esta ação é irreversível. Preencha o motivo para prosseguir com o cancelamento.
        </p>

        <div style={{ margin: "16px 0", textAlign: "left" }}>
          <label style={{ display: "block", marginBottom: 6, fontWeight: 600, fontSize: 13, color: "#464E5F" }}>
            Motivo do cancelamento <span style={{ color: "#F64E60" }}>*</span>
          </label>
          <textarea
            placeholder="Descreva o motivo do cancelamento..."
            value={cancellationReason}
            onChange={e => setCancellationReason(e.target.value)}
            maxLength={reasonMaxLength}
            rows={4}
            style={{
              width: "100%",
              borderRadius: 6,
              border: error ? "1px solid #F64E60" : "1px solid #E4E6EF",
              padding: "10px 12px",
              resize: "vertical",
              fontSize: 14
            }}
            disabled={isLoading}
          />
          {error && (
            <div style={{ color: "#F64E60", fontSize: 12, marginTop: 4 }}>
              {error}
            </div>
          )}
        </div>

        <div style={{ marginTop: 24, display: "flex", justifyContent: "center", gap: 12 }}>
          <button
            className="btn"
            onClick={handleDismiss}
            disabled={isLoading}
            style={{
              padding: "10px 24px",
              backgroundColor: "#F3F6F9",
              color: "#7E8299",
              border: "none",
              borderRadius: 6,
              fontWeight: 600
            }}
          >
            Voltar
          </button>
          <button
            className="btn"
            onClick={handleConfirm}
            disabled={isLoading}
            style={{
              padding: "10px 24px",
              backgroundColor: "#FFF5F5",
              color: "#F64E60",
              border: "1px solid #F64E60",
              borderRadius: 6,
              fontWeight: 600,
              transition: "all 0.2s ease"
            }}
            onMouseEnter={(e) =>
              handleHoverStyle(e, "#F64E60", "#fff")
            }
            onMouseLeave={(e) =>
              handleHoverStyle(e, "#FFF5F5", "#F64E60")
            }
          >
            {isLoading ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2"></i>
                Processando...
              </>
            ) : (
              "Confirmar Cancelamento"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

